// extracted by mini-css-extract-plugin
export var authorContainer = "authors-module--authorContainer--f77cb";
export var authorDescription = "authors-module--authorDescription--1e2f4";
export var authorDetails = "authors-module--authorDetails--80412";
export var authorImage = "authors-module--authorImage--2b31c";
export var authorImageFallback = "authors-module--authorImageFallback--0a668";
export var authorName = "authors-module--authorName--d859f";
export var authorTitle = "authors-module--authorTitle--d9c7a";
export var isArchive = "authors-module--isArchive--eac74";
export var noTableOfContents = "authors-module--noTableOfContents--93a3e";
export var singleAuthor = "authors-module--singleAuthor--83777";
export var socialAuthorLinks = "authors-module--socialAuthorLinks--abea3";
export var styledAuthors = "authors-module--styledAuthors--bdae8";
export var styledCoAuthorIcon = "authors-module--styledCoAuthorIcon--69199";